/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VitalityDrugDescription
 */
export interface VitalityDrugDescription {
    /**
     * 
     * @type {string}
     * @memberof VitalityDrugDescription
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof VitalityDrugDescription
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof VitalityDrugDescription
     */
    route?: string;
    /**
     * 
     * @type {number}
     * @memberof VitalityDrugDescription
     */
    price?: number;
}

/**
 * Check if a given object implements the VitalityDrugDescription interface.
 */
export function instanceOfVitalityDrugDescription(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VitalityDrugDescriptionFromJSON(json: any): VitalityDrugDescription {
    return VitalityDrugDescriptionFromJSONTyped(json, false);
}

export function VitalityDrugDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): VitalityDrugDescription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'price': !exists(json, 'price') ? undefined : json['price'],
    };
}

export function VitalityDrugDescriptionToJSON(value?: VitalityDrugDescription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'route': value.route,
        'price': value.price,
    };
}

